<template>
    <div>
        <label>{{ label }}</label>
        <select
            name="garrison_id"
            id="garrison_select"
            class="form-control garrison-select"
            v-validate="validation_rule"
            v-model="selectedGarrison"
            @change="garrisonSelected()">
            <option
                disabled selected
                value="null">
                --- Valitse varuskunta ---
            </option>
            <option
                v-for='garrison in garrisons'
                :value="garrison.id">
                {{ garrison.name }}
            </option>
        </select>

        <select
            name="unit_id"
            class="form-control"
            :disabled="(selectedGarrison == null || selectedGarrison == undefined)"
            v-model="selectedUnit"
            v-validate="validation_rule"
            @change="unitSelected()">
            <option
                disabled selected
                value="null">
                --- Valitse yksikkö ---
            </option>
            <template v-for='unit in this.unitByGarrison'>
                <option
                    :value=unit.id>
                    {{ unit.name }}
                </option>
            </template>
        </select>
    </div>
</template>
<script>
    export default {

        inject: ['$validator'],
        props: ['label', 'garrisons', 'units', 'default_unit', 'default_garrison', 'validation_rule'],
        data() {
            return {
                selectedGarrison: null,
                selectedUnit: null,
            }
        },
        computed: {
            unitByGarrison: function () {
                return this.selectedGarrison == null ? this.units : this.units.filter(unit => unit.garrison_id == this.selectedGarrison);
            }
        },
        methods: {
            unitSelected() {
                this.$emit('input', this.selectedUnit);
            },
            garrisonSelected() {
                this.$emit('input', this.selectedGarrison);
                this.selectedUnit = null;
                this.$nextTick(() =>  {
                    this.$validator.validate();
                });
            },
        },
        mounted() {
            if (this.default_garrison != null || this.default_unit != null) {
                this.selectedGarrison = this.default_garrison.id;
                this.selectedUnit = this.default_unit.id;
            }
        }
    }
</script>

<style>
    .garrison-select {
        margin-bottom: 8px;
    }
</style>
